import FeedPost, { FeedPostStateProps, FeedPostDispatchProps, FeedPostOwnProps } from 'components/features/socialFeed/FeedPost/FeedPost'
import { StoreDispatch } from 'interfaces/component'
import { toggleEditPostActionCreator } from 'actions/feedActions'
import { feedAppSelector, createPostAuthorSelector, createRegularPostSelector } from 'selectors/feedSelectors'
import { connectOptionally, OptionalRendererProps, createOptionalRenderer } from 'tangle-shared'
import { State } from 'interfaces/state'
import { createFeedPostImagesSelector } from 'selectors/feedImagesSelectors'
import { feedComposeCleanUpActionCreator } from 'actions/feedComposeActions'

const mapStateToProps = () => {
  const postSelector = createRegularPostSelector()
  const authorSelector = createPostAuthorSelector()
  const optionalRenderer = createOptionalRenderer<FeedPostStateProps>()
  const imagesSelector = createFeedPostImagesSelector()

  return (state: State, ownProps: FeedPostOwnProps): OptionalRendererProps<FeedPostStateProps> => {
    const post = postSelector(state, ownProps)

    if (!post) {
      return optionalRenderer.fallback()
    }

    const images = imagesSelector(state, ownProps)
    const feedLoadingStates = feedAppSelector(state)

    return optionalRenderer.render({
      post,
      images,
      author: authorSelector(state, ownProps),
      isLikeLoading: Boolean(feedLoadingStates.likingPostUids[post.uid]),
      isPostFollowLoading: Boolean(feedLoadingStates.postFollowingLoadingIds[post.uid]),
      isPostEditing: Boolean(feedLoadingStates.editingPostsIds[post.uid]),
    })
  }
}

const mapDispatchToProps = (dispatch: StoreDispatch, ownProps: FeedPostOwnProps): FeedPostDispatchProps => {
  const { postUid } = ownProps

  return {
    onPostEdit: (isEditing) => dispatch(
      toggleEditPostActionCreator({ isEditing, postUid })
    ),
    onCancelEdit: (composeId) => dispatch(
      feedComposeCleanUpActionCreator.request({
        composeId,
      })
    ),
  }
}

const FeedPostContainer = connectOptionally<
  FeedPostStateProps,
  FeedPostDispatchProps,
  FeedPostOwnProps
>(mapStateToProps, mapDispatchToProps)(FeedPost)

export default FeedPostContainer
